import React, { useRef, useEffect } from 'react';

import AuthInputComponent from "../AuthInputComponent/AuthInputComponent";
import AuthBtnsComponent from "../AuthBtnComponent/AuthBtnsComponent";
import useDoAuth from "../../../hooks/useDoAuth";
import AuthSpinnerComponent from '../AuthSpinnerComponent';

interface Props {
  authFetch: boolean
}

const AuthFormComponent: React.FC<Props> = ({authFetch}) => {
  const user = useRef<HTMLInputElement>(null);
  const password = useRef<HTMLInputElement>(null);
  const {onsubmit, oncancel} = useDoAuth({user, password});

  useEffect(() => {
    user.current?.focus();
  });

  return (
    <div className='auth-form-wrapper'>
      <form id="auth-form" action="/" onSubmit={onsubmit}>
        <AuthInputComponent type='text'
                            name='username'
                            label='username'
                            id='login'
                            refCustom={user}
                            title={'Enter Username'}
                            disabled={authFetch}
                            readonly={authFetch}
        />
        <AuthInputComponent type='password'
                            name='password'
                            label='password'
                            id='password'
                            refCustom={password}
                            title={'Enter Password'}
                            disabled={authFetch}
                            readonly={authFetch}
        />

        <div className={`btns-wrapper ${authFetch ? 'fetch' : ''}`}>
          <AuthBtnsComponent oncancel={oncancel}
                             onsubmit={onsubmit}
          />
          {authFetch && <div className='spinner-wrapper'>
            <AuthSpinnerComponent/>
          </div>
          }
        </div>
        <input type="submit" value='' className='d-none'/>
      </form>
    </div>
  )
};

export default AuthFormComponent;